module.exports = __webpack_public_path__ + "img/placeholder.0a4f00db.jpg";